<template>
<div class="turn-bg">
  <div
    v-if="isShowHead"
    :class="['turn-head', partnerName]">
    <div class="turn-head__logo">
      <a @click="$router.go(-1)">
        <img src="/images/angle-left_white.svg">
      </a>
      <img :src="getParnterLogo()" />
    </div>
  </div>
  <div class="turn-body">
    <div
      class="winner__head"
      v-if="winnerList">
      <span>{{ dateTitle }}</span>
      幸運名單
    </div>
    <div
      class="winner__content"
      v-if="winnerList">
      <table
        v-for="winner in winnerList"
        :key="winner.index">
        <tr>
          <th>姓名</th>
          <th>購買金額</th>
        </tr>
        <tr>
          <td>{{winner.consumerName}} ({{winner.consumerTel}})</td>
          <td>{{winner.cash}}</td>
        </tr>
        <tr>
          <td
            class="prize"
            colspan="2">
            <div>{{winner.productName}}</div>
          </td>
        </tr>
      </table>
    </div>
    <div
      class="winner__wait-trophy"
      v-else>等候幸運名單出現！
      <img src="/images/wait-trophy.svg" alt="等候幸運名單出現！">
    </div>
  </div>
  <Footer></Footer>
</div>
</template>

<script>
import Footer from './components/footer.vue';
export default {
  name: 'Winner',
  data() {
    return {
      partnerName: 'friday',
      isShowHead: true,
      dateTitle: '',
      winnerList: null,
    }
  },
  components: {
    Footer
  },
  created() {
    // export vue router
    window['vue_router'] = this.$route

    if (this.$route.params && this.$route.params.partnerName) {
      this.partnerName = this.$route.params.partnerName
    }

    if (/device=app/i.test(location.search)) {
      this.isShowHead = false
    }
    window.scrollTo(0, 0)

    const d = new Date();
    d.setDate(d.getDate() - 1)
    this.dateTitle = d.getMonth() + 1 + '/' + d.getDate()

    this.winnerApi.getWinnerList().then(res => {
      if (res.data && res.data.length > 0) {
        this.winnerList = res.data
      }
    })
  },
  methods: {
    getParnterLogo() {
      return `/images/${this.partnerName}/h_logo.svg`
    },
    backPage(evt) {
      evt.preventDefault();
      window.history.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.turn-bg {
  background-color: #eee
}
.turn-head {
  background-color: #ff0063;

  &.metrotaipei {
    background: linear-gradient(90deg, #014d79, #059c76);
    img {
      width: 80%;
    }
  }

  &__logo {
    height: 40px;
    display: flex;
    align-items: center;
    a {
      display: inline-block;
      position: absolute;
      left: 10px;
    }
    img:first-of-type {
      height: 20px;
    }
    img:last-of-type {
      cursor: pointer;
      height: 25px;
      margin: auto;
    }
  }
}
.turn-body {
  min-height: calc(100vh - 130px);
  padding: 0 10px;
  .winner__head {
    color: #f05;
    font-size: 2rem;
    text-align: center;
    padding: 1rem 0;
  }
  .winner__content {
    display: grid;
    width: 360px;
    margin: 0 auto;
    margin-bottom: 50px;
    font-size: 1.4rem;
    text-align: center;
    gap: 10px;
    table {
      width: 100%;
      max-width: 360px;
      border-collapse: collapse;
      tr,th,td {
        font-weight: unset;
        padding: 7px;
      }
      tr:not(:last-of-type) {
        border-bottom: 1px solid #ccc;
      }
      th:first-of-type, td:first-of-type:not(:last-of-type) {
        border-right: 1px solid #ccc;
      }
      th {
        color: #555;
        background-color: #fdd;
      }
      td {
        color: #000;
        background-color: #fff;
        &.prize {
          text-align: start;
        }
      }
    }
  }
  .winner__wait-trophy {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    font-weight: normal;
    font-size: 2.0rem;
    letter-spacing: 0.3rem;
    img {
      max-width: 100px;
      margin-top: 20px;
    }
  }
}
@media screen and (min-width: 765px) {
    tr,th,td {
      font-size: 16px !important;
    }
  .winner__content {
    width: 750px !important;
    gap: 15px !important;
    grid-template-columns: 1fr 1fr;
    td {
      div { 
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
    }
  }
}

@media screen and (min-width: 1130px) {
  .turn-head__logo {
    height: 60px;
    img {
      height: 40px !important;
      &:first-of-type {
        left: 20px;
      }
    }
  }
  .winner__content {
    width: 1100px !important;
    gap: 20px !important;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
